import StrategyLaunchPage from "@Quest/Strategies/Pages/StrategyLaunchPage.vue";
import StrategyFixPage from "@Quest/Strategies/Pages/StrategyFixPage.vue";
import StrategySettingsPage from "@Quest/Strategies/Pages/StrategySettingsPage.vue";
import ProjectPlanTemplatesPage from "@Quest/Strategies/Pages/ProjectPlanTemplatesPage.vue";
import AllProjectsPage from "@Quest/Strategies/Pages/AllProjectsPage.vue";
import ProposedProjectsPage from "@Quest/Strategies/Pages/ProposedProjectsPage.vue";
import ScheduledProjectsPage from "@Quest/Strategies/Pages/ScheduledProjectsPage.vue";
import StartedProjectsPage from "@Quest/Strategies/Pages/StartedProjectsPage.vue";
import FinishedProjectsPage from "@Quest/Strategies/Pages/FinishedProjectsPage.vue";

export const routes = [
    {
        path: "/strategy/:workspaceId",
        component: StrategyLaunchPage
    },
    {
        path: "/enterprise/fix/:workspaceId/:strategyId?",
        component: StrategyFixPage
    },
    {
        path: "/enterprise/settings/:workspaceId/:strategyId",
        component: StrategySettingsPage
    },
    {
        path: "/enterprise/business-case-templates/:workspaceId/:strategyId",
        component: ProjectPlanTemplatesPage
    },

    {
        path: "/enterprise/projects/all/:workspaceId/:strategyId",
        component: AllProjectsPage
    },
    {
        path: "/enterprise/projects/proposals/:workspaceId/:strategyId",
        component: ProposedProjectsPage
    },
    {
        path: "/enterprise/projects/scheduled/:workspaceId/:strategyId",
        component: ScheduledProjectsPage
    },
    {
        path: "/enterprise/projects/started/:workspaceId/:strategyId",
        component: StartedProjectsPage
    },
    {
        path: "/enterprise/projects/finished/:workspaceId/:strategyId",
        component: FinishedProjectsPage
    },
]
